var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.xAxis.length)?_c('div',[_c('highcharts',{attrs:{"options":_vm.chartData}})],1):_c('div',{staticClass:"p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50"},[_c('span',{staticClass:"font-medium"},[_vm._v("No Data! ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }